import React, { useState, useEffect } from "react";
import TableModule from "../../components/TableModule";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCubes, faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useCallback } from "react";
import apiClient from "../../axios";

const PoliciesModal = ({ isVisible, onClose, onAddModules, initialSelectedModules }) => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedModules, setSelectedModules] = useState(initialSelectedModules || null);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 10;

    const processFetchedData = (data, initialSelectedModules) => {
        const groupedData = data.reduce((acc, item) => {
            const existing = acc.find((group) => group.moduleId === item.moduleId);
            if (existing) {
                existing.paymentDetails.push({ ...item });
            } else {
                acc.push({
                    ...item,
                    paymentDetails: [{ ...item }],
                    selectedPaymentPeriod: item.paymentPeriod,
                    selectedDescription: item.description,
                });
            }
            return acc;
        }, []);

        groupedData.forEach((group) => {
            group.paymentDetails.sort((a, b) => a.paymentPeriod - b.paymentPeriod);
            const firstDetail = group.paymentDetails[0];
            const previouslySelected = initialSelectedModules?.find(
                (mod) => mod.moduleId === group.moduleId
            );
            if (previouslySelected) {
                group.selectedPaymentPeriod = previouslySelected.paymentPeriod;
                group.selectedDescription = previouslySelected.description;
            } else {
                group.selectedPaymentPeriod = firstDetail.paymentPeriod;
                group.selectedDescription = firstDetail.description;
            }
        });

        return groupedData;
    };

    const fetchAllData = useCallback(async () => {
        try {
            setLoading(true);
            /*const response = await apiClient.get(`/module_pack?productType=COMBOS&page=${page}`);
            if (Array.isArray(response.data.results)) {
                setData(processFetchedData(response.data.results));
                setTotalItems(response.data.total);
            } else {
                setData([]);
                setTotalItems(0);
            }*/
            const response = await apiClient.get(`/module_pack/purchase?productType=POLIZAS`);
            if (Array.isArray(response.data)) {
                setData(processFetchedData(response.data, initialSelectedModules));
                setTotalItems(response.data.length);
            } else {
                setData([]);
                setTotalItems(1);
            }
        } catch (error) {
            console.error("Error al obtener los datos del servicio", error);
        } finally {
            setLoading(false);
        }
    }, [initialSelectedModules]);

    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]); // Añadido 'fetchAllData' a las dependencias

    const handleRefresh = useCallback(() => {
        fetchAllData();
    }, [fetchAllData]);

    /*useEffect(() => {
        if (isVisible) {
            setSelectedModule(initialSelectedModule || null);
        }
    }, [isVisible, initialSelectedModule]);*/
    useEffect(() => {
        if (isVisible) {
            handleRefresh();
            setSelectedModules(initialSelectedModules ? initialSelectedModules.map(mod => mod.moduleCode) : []);
        }
    }, [handleRefresh, isVisible, initialSelectedModules]);
    useEffect(() => {
        if (initialSelectedModules) {
            const codes = initialSelectedModules.map(mod => mod.moduleCode);
            setSelectedModules(codes);
        } else {
            setSelectedModules([]);
        }
    }, [initialSelectedModules]);

    const handleSave = () => {
        const selectedData = data
            .filter((item) => selectedModules.includes(item.moduleCode))
            .map((item) => {
                const selectedDetail = item.paymentDetails.find(
                    (detail) => detail.paymentPeriod === item.selectedPaymentPeriod
                );
                return {
                    ...selectedDetail,
                    count: 0,
                    productType: "COMBOS" //agregado
                };
            });

        onAddModules(selectedData, "COMBOS");
        onClose();
    };

    const handleCheckboxChange = (moduleCode) => {
        setSelectedModules((prevSelected) =>
            prevSelected.includes(moduleCode)
                ? prevSelected.filter((code) => code !== moduleCode)
                : [...prevSelected, moduleCode]
        );
    };

   

    const renderRow = (item) => {
        return (
            <>
                <td>{item.moduleName}</td>
                <td>{item.selectedDescription}</td>
                <td>{item.paymentPeriod} meses</td>
                <td>${item.purchasePrice.toFixed(2)}</td>
                <td>
                    <input
                        type="checkbox"
                        checked={selectedModules.includes(item.moduleCode)}
                        onChange={() => handleCheckboxChange(item.moduleCode)}
                    />
                </td>
            </>
        );
    };

    return (
        isVisible && (
            <div className="modal-overlay">
                <div className="modal-content-module">
                    <div className="modal-content-module-body">
                        <h3 className="modal-title">POLIZAS</h3>
                        <TableModule
                            title="Lista de POLIZAS"
                            rows={data}
                            columns={[
                                { title: "Nombre", key: "description" },
                                { title: "Descripción", key: "description" },
                                { title: "Meses", key: "extraSus" },
                                { title: "Precio Módulo", key: "precioSus" },
                                { title: "Seleccionar", key: "acciones" },
                            ]}
                            icon={faCubes}
                            renderRow={renderRow}
                            currentPage={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={setCurrentPage}
                            onRefresh={handleRefresh}
                            isAllSelected={selectedModules && data.length === 1}
                            loading={loading}
                        />
                    </div>
                    <div className="modulesmodal-basic-form-footer">
                        <button className="basic-custom-button" onClick={onClose}>
                            <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                            Cancelar
                        </button>
                        <button className="basic-custom-button" onClick={handleSave}>
                            <FontAwesomeIcon icon={faCheck} className="basic-shortcut-icon" />
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default PoliciesModal;
